import { Environment, getEnvironment } from "./getEnvironment";

const environments: Environment[] = [
  'local', 
  'development',
  'release',
  // 'production'
];

const isLearningHubEnabledFunc = (): boolean => {
  const environment = getEnvironment();
  return environments.includes(environment);
};

export const isLearningHubEnabled = isLearningHubEnabledFunc();